export default {
      id: "telephone-usage",
      viewBox: "0 0 13 14",
      url: "../dist/images/" + "sprite.svg#telephone-usage",
      toString: function () {
        return this.url;
      }
    }